import React from 'react'

const SvgCalendarClockOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 2c.667 0 1 .314 1 .941V4h1c1.333 0 2 .667 2 2v4.252A8.01 8.01 0 0018 10H6v10h4.252c.183.71.463 1.38.821 2H6c-1.333 0-2-.667-2-2V6.004C4 4.668 4.667 4 6 4h1V3c-.002-.667.33-1 1-1 .67 0 1.004.333 1.004 1v1H15V2.941c0-.627.333-.941 1-.941zM6 8h12V6H6v2z'
    />
    <path d='M10 16c.088 0 .17.006.247.018A8.016 8.016 0 0010 18H9c-.667.001-1-.332-1-1 0-.668.335-1.001 1.002-1H10zM10 12c.667 0 1 .333 1 1s-.333 1-1 1H9c-.667.001-1-.332-1-1 0-.668.335-1.001 1.002-1H10z' />
    <path fillRule='evenodd' clipRule='evenodd' d='M18 22a4 4 0 110-8 4 4 0 010 8zm0 2a6 6 0 110-12 6 6 0 010 12z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 15.25a.75.75 0 01.75.75v1.69l.78.78a.75.75 0 11-1.06 1.06l-1-1a.75.75 0 01-.22-.53v-2a.75.75 0 01.75-.75z'
    />
  </svg>
)

export default SvgCalendarClockOutline
